import { MaritalStatus } from '../enums/marital-status.enum';

export const MARITAL_STATUS = [
	{ label: 'Solteiro', value: MaritalStatus.SOLTEIRO },
	{ label: 'Casado', value: MaritalStatus.CASADO },
	{ label: 'Separado', value: MaritalStatus.SEPARADO },
	{ label: 'Divorciado', value: MaritalStatus.DIVORCIADO },
	{ label: 'Viúvo', value: MaritalStatus.VIUVO },
	{ label: 'União Estável', value: MaritalStatus.UNIAO_ESTAVEL },
	{ label: 'Outros', value: MaritalStatus.OUTROS },
];
